import { render, staticRenderFns } from "./DesignDetails.vue?vue&type=template&id=56719fac&"
import script from "./DesignDetails.vue?vue&type=script&lang=js&"
export * from "./DesignDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports